/* unplugin-vue-components disabled */import script from "./submitRule.vue?vue&type=script&setup=true&lang=js"
export * from "./submitRule.vue?vue&type=script&setup=true&lang=js"

import "./submitRule.vue?vue&type=style&index=0&id=37285dd3&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37285dd3"]])

export default __exports__